'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function trimStart(str, chars) {
    if (chars === undefined) {
        return str.trimStart();
    }
    var startIndex = 0;
    switch(typeof chars === "undefined" ? "undefined" : _type_of(chars)){
        case 'string':
            {
                while(startIndex < str.length && str[startIndex] === chars){
                    startIndex++;
                }
                break;
            }
        case 'object':
            {
                while(startIndex < str.length && chars.includes(str[startIndex])){
                    startIndex++;
                }
            }
    }
    return str.substring(startIndex);
}
exports.trimStart = trimStart;
